import { useContext } from 'react';
import { AppContext } from '../AppContext';
import { INVENTORY_UNITS_ENABLED_LIBRARIES } from '../common/constants';

const ALL = 'ALL';

export const isUnitsFeatureEnabledForLibrary = (libraryId) =>
  INVENTORY_UNITS_ENABLED_LIBRARIES?.includes(ALL) ||
  (Boolean(libraryId) &&
    INVENTORY_UNITS_ENABLED_LIBRARIES?.includes(`${libraryId}`.toUpperCase()));

const useInventoryUnitsFeature = (libraryId) => {
  const {
    state: { currentUser },
  } = useContext(AppContext);

  const isUnitsFeatureEnabled = isUnitsFeatureEnabledForLibrary(
    libraryId === undefined ? currentUser?.libraryId : libraryId,
  );

  return { isUnitsFeatureEnabled };
};

export default useInventoryUnitsFeature;
